<template>
  <div>
    <Hero is-info-page class="h-full" />
    <DrIcon
      svg="delete-circle"
      height="24"
      width="24"
      class="mt-3  mr-2 absolute right-0 cursor-pointer z-20"
      @click.native="closeWidget"
    />
    <Portal v-if="!isSanctionsSearchFlagged()" to="hero-extra">
      <div class="pt-20 pb-10 h-full px-8 success-page bg-green-500">
        <div v-if="!$store.state.portal" class="relative mx-auto max-w-md h-full">
          <h1 class="text-xl">You're all set!</h1>
          <div class="text-center acc-reference">
            <p class="mb-0">Your account reference is</p>
            <p class="text-2xl" data-cy="text-reference-number">
              {{ $store.getters.getConvertedToAccountRef }}
            </p>
          </div>
          <p class="leading-normal">
            You will shortly receive an email with your policy documents (please check your junk folder and contact us if you don’t receive the email within 24 hours).
          </p>

          <template v-if="isCustomerPortalAvailable()">
            <p>
              You can also download a copy of your documents from your online account as soon as they become available.
            </p>

            <a class="btn btn-cyan text-blue-700 mx-auto no-underline mb-4" href="https://my.digitalrisks.co.uk/">Login</a>
          </template>

          <p class="leading-normal pr-8">
            If you have any questions about your policy or account, please call us on 033 3772 0759.
          </p>
        </div>
        <div v-else class="relative mx-auto max-w-md h-full flex flex-col items-center text-center acc-reference">
          <div class="text-xl font-bold mt-16">You're all set!</div>
          <p class="font-semibold mt-3">Your business insurance has now been updated.</p>
          <div class="mt-auto mb-20 w-full done-button">
            <DrButton
              class="btn btn-cyan w-full rounded-full text-blue-700 font-semibold"
              @click.prevent="closeWidget(null, true)"
            >
              Close
            </DrButton>
          </div>
        </div>
      </div>
    </Portal>
    <Portal v-else to="hero-extra">
      <div class="pt-20 pb-10 h-full px-8 mx-auto max-w-md error-page">
        <div class="relative h-full">
          <h1 class="text-xl">Almost there!</h1>
          <p>
            We need to run some final checks before we get you set up - your payment method has not yet been charged.
          </p>
          <p class="leading-normal">
            One of our team will be in touch shortly. If you’d like to get in touch in the meantime please give us a
            call on
            <a class="text-white no-underline hover:text-white" href="tel:+443337720759">
              0333 772 0759
            </a>
            or send an email to
            <a
              class="text-white no-underline hover:text-white"
              :href="`mailto:hello@digitalrisks.co.uk`"
              target="_blank" rel="noopener noreferrer"
            >
              hello@digitalrisks.co.uk
            </a>
            .
          </p>
          <p v-if="$store.getters.getReference" class="leading-normal">
            Quote your reference number {{ $store.getters.getReference }}.
          </p>
          <div class="absolute bottom-0 block sm:flex w-full">
            <DrButton class="btn btn-cyan w-full rounded-full text-blue-700 font-semibold" @click.prevent="closeWidget(null, true)">
              Close
            </DrButton>
          </div>
        </div>
      </div>
    </Portal>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  created () {
    this.sendTransactionDataToGtm()
    Cookies.remove('dr-store')
  },
  methods: {
    sendTransactionDataToGtm () {
      window.dataLayer = window.dataLayer || []
      const payload = {
        event: 'Sale',
        transactionId: this.$store.getters.getQuoteId,
        transactionAffiliation: 'Digital Risks',
        transactionTotal: this.$store.getters.getQuoteTotal,
        transactionTax: this.$store.getters.getIptTotal,
        transactionProducts: this.$store.getters.getProducts.map(function (product) {
          return {
            sku: product.rates[0].key,
            name: product.rates[0].key,
            category: product.key,
            price: Number(Number(product.total).toFixed(2)),
            quantity: 1,
          }
        }),
      }
      window.dataLayer.push({ quoteValue: this.$store.getters.getQuoteTotal })
      window.dataLayer.push(payload)
    },
    closeWidget (route, refresh = false) {
      const payload = { from: 'dr-widget', refresh }
      if (route) payload.redirect = route
      window.parent.postMessage({ type: 'close-iframe', payload }, '*')
    },
    isSanctionsSearchFlagged () {
      if (!this.$store.getters.getSanctionsSearchRecord) return false

      const resultset = Object.values(this.$store.getters.getSanctionsSearchRecord.searchResults)

      return resultset.flat().find(result => result.resultSimilarity && result.resultSimilarity > 0.8) !== undefined
    },
    isCustomerPortalAvailable () {
      // Not allow for appear-here customers
      return this.$store.getters.getSource !== 'appear-here'
    },
  },
}
</script>

<style scoped>
@media (max-width: 320px) {
  .success-page {
    @apply pt-5 pb-5 px-5;
  }

  .done-button {
    bottom: 40px;
  }
}

@media (min-width: 376px) {
  .acc-reference {
    @apply py-0;
  }
}

@media screen and (orientation: landscape) and (max-height: 660px) {
  .success-page {
    overflow-y: scroll;
  }

  .success-page > div {
    @apply h-auto;
  }

  .acc-reference {
    @apply py-0;
  }

  .done-button {
    @apply relative mt-8;
  }
}
</style>
